export default function setButtonPosition() {
  const viewportHeight = window.visualViewport.height;
  const initHeightValue = Number(sessionStorage.getItem('initHeightValue'));
  const viewportHeightValue = Number(sessionStorage.getItem('viewportHeightValue'));
  const reload = sessionStorage.getItem('reload');
  const actionBarWrapperArr = document.querySelectorAll('.actionBarWrapper');
  const mailPage = document.getElementById('mailPage');
  const mailsecurity = document.getElementById('mailsecurity');
  const activeMailPage = document.querySelector('.activeMailPage');

  if (actionBarWrapperArr && viewportHeight > 440) {
    if (viewportHeight < viewportHeightValue && !reload) {
      sessionStorage.setItem('reload', true);
    }

    let newTopPosition = viewportHeight - 108;

    if (initHeightValue < viewportHeight) {
      newTopPosition = initHeightValue - 108;
    }

    if (viewportHeightValue < viewportHeight && Boolean(reload)) {
      newTopPosition = viewportHeightValue - 108;
    } else if (viewportHeightValue < viewportHeight) {
      newTopPosition = viewportHeight - 108;
    }

    if (mailPage && initHeightValue > viewportHeight) {
      newTopPosition = initHeightValue - 118;
    }

    if (mailPage && mailsecurity && activeMailPage) {
      if (viewportHeightValue < viewportHeight && Boolean(reload)) {
        newTopPosition = viewportHeightValue - 154;
        mailsecurity.style.top = `${viewportHeightValue - 36}px`;
      } else if (viewportHeightValue < viewportHeight) {
        newTopPosition = viewportHeight - 144;
        mailsecurity.style.top = `${viewportHeight - 36}px`;
      } else if (viewportHeightValue > viewportHeight) {
        newTopPosition = viewportHeightValue - 144;
        mailsecurity.style.top = `${viewportHeightValue - 36}px`;
      } else {
        newTopPosition = viewportHeight - 144;
        mailsecurity.style.top = `${initHeightValue - 36}px`;
      }
    }

    for (let i = 0; i < actionBarWrapperArr.length; i++) {
      if (actionBarWrapperArr[i]) {
        actionBarWrapperArr[i].style.top = `${newTopPosition}px`;
      }
    }
  }
}
